import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

const AUTH_PATH = /^\/(login|register|logout|auth)(\/|$)/;

const REDIRECT_KEY = 'redirectUrl';

const isAuthPath = (target: string): boolean =>
  target === '/' || AUTH_PATH.test(target);

/**
 * Sprint 39, story-212. Logged-out only. A known (gated or role-gated) app path was requested:
 * remember it so `useLogin` can restore it after sign-in, then go to the login page. Never
 * overwrites an existing saved non-auth path with an auth path. The write is idempotent, so a
 * double render is harmless (same render-time write the PrivateRoutes make).
 */
const KnownPathRedirect: React.FC = () => {
  const { pathname, search, hash } = useLocation();

  if (!isAuthPath(pathname)) {
    sessionStorage.setItem(REDIRECT_KEY, `${pathname}${search}${hash}`);
  }

  return <Redirect to="/login" />;
};

export default KnownPathRedirect;
